import { stringArrayToObject } from '../../utils/array';
import { actionCreators as toastActions } from '../Toasts/actions';

import I18n from '../../config/i18n';

import { createNewProduct, createNewProductQR } from '../../services/ProductServices';

/* ------------- Country actions ------------- */
export const actions = stringArrayToObject(
  [
    'CLEAR',
    'SET_INFO',
    'CHANGE_PAGE',
    'NEXT_PAGE',
    'PREV_PAGE',
    'START_CREATION',
    'END_CREATION_SUCCESS',
    'END_CREATION_FAIL',
  ],
  '@NEW_PRODUCT_FORM',
);

const privateActionsCreators = {
  startCreation() {
    return {
      type: actions.START_CREATION,
    };
  },
  endCreationFail(error) {
    return {
      type: actions.END_CREATION_FAIL,
      payload: { error },
    };
  },
  endCreationSuccess(product, qr) {
    return {
      type: actions.END_CREATION_SUCCESS,
      payload: { product, qr },
    };
  },
};

export const actionCreators = {
  clearForm() {
    return {
      type: actions.CLEAR,
    };
  },
  setProductInfo(product) {
    return {
      type: actions.SET_INFO,
      payload: { product },
    };
  },
  changePage(page) {
    return {
      type: actions.CHANGE_PAGE,
      payload: { page },
    };
  },
  nextPage() {
    return {
      type: actions.NEXT_PAGE,
    };
  },
  prevPage() {
    return {
      type: actions.PREV_PAGE,
    };
  },
  createNewProduct(product, pictureData, meshData) {
    return async (dispatch) => {
      dispatch(privateActionsCreators.startCreation());
      const productResponse = await createNewProduct(product, pictureData, meshData);
      if (!productResponse.ok) {
        dispatch(privateActionsCreators.endCreationFail(productResponse.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: productResponse.error,
        }));
        return;
      }
      const qrResponse = await createNewProductQR(productResponse.product.id);
      const url = qrResponse.url || null;
      dispatch(privateActionsCreators.endCreationSuccess(productResponse.product, url));
      if (productResponse.partial) {
        dispatch(toastActions.addToast({
          type: 'danger',
          message: I18n.t('forms.newProduct.messages.partialSuccess'),
        }));
      } else {
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('forms.newProduct.messages.success'),
        }));
      }
    };
  },
  createNewProductQR(id) {
    return async (dispatch) => {
      const qrResponse = await createNewProductQR(id);
      if (!qrResponse.ok) {
        dispatch(privateActionsCreators.endCreationFail(qrResponse.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: qrResponse.error,
        }));
        return;
      }
      dispatch(toastActions.addToast({
        type: 'success',
        message: I18n.t('forms.newProduct.messages.qrCreated'),
      }));
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/NewProductForm/actions.js